var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled, { css } from 'styled-components';
import { getFocusStyles, Icon, Shape, Spacing, withTheming } from '@doordash/design-language';
import { ControlPadding } from './constants';
export var MenuControlButton = withTheming(styled.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: ", "px;\n  color: ", ";\n  border-radius: ", "px;\n  z-index: 1;\n  padding: ", ";\n  border: none;\n  box-shadow: ", ";\n  background-color: ", ";\n  white-space: nowrap;\n  max-width: 100%;\n  ", ";\n\n  ", "\n\n  &:focus-within {\n    background-color: ", ";\n    ", ";\n  }\n"])), function (props) {
  return function (_ref) {
    var theme = _ref.theme;
    return theme.Size["Field".concat(props.size)];
  };
}, function (props) {
  return props.theme.Colors.FieldsForegroundInactive;
}, function (props) {
  return function (_ref2) {
    var theme = _ref2.theme;
    return theme.Shape.Field === Shape.Pill ? theme.Size["Field".concat(props.size)] * 2 : theme.BorderRadius.FieldsInputDefault;
  };
}, function (props) {
  return "0px ".concat(ControlPadding[props.size], "px");
}, function (_ref3) {
  var theme = _ref3.theme;
  return "inset 0 0 0 ".concat(theme.BorderWidth.FieldsDefault, "px ").concat(theme.Colors.FieldsBorderInactive);
}, function (props) {
  return function (_ref4) {
    var theme = _ref4.theme;
    return props.isExpanded ? theme.Colors.FieldsBackgroundActive : theme.Colors.FieldsBackgroundInactive;
  };
}, function (props) {
  return !props.isInline && "min-width: 100%";
}, function (props) {
  return function (_ref5) {
    var theme = _ref5.theme;
    return props.isExpanded && getFocusStyles({
      focusColor: theme.Colors.FieldsBorderActive,
      shouldUseFocusRing: false,
      shouldBeInset: true,
      focusWidth: theme.BorderWidth.FieldsFocus
    });
  };
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.Colors.FieldsBackgroundActive;
}, function (_ref7) {
  var theme = _ref7.theme;
  return getFocusStyles({
    focusColor: theme.Colors.FieldsBorderActive,
    shouldUseFocusRing: false,
    shouldBeInset: true,
    focusWidth: theme.BorderWidth.FieldsFocus
  });
}));
export var MenuContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding: ", "px 0;\n  ", ";\n"])), Spacing.XxSmall, function (props) {
  return props.menuContainerStyles && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      ", ";\n    "])), _objectSpread({}, props.menuContainerStyles));
});
export var MenuItemContainer = withTheming(styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", "\n"])), function (props) {
  return function (_ref8) {
    var theme = _ref8.theme;
    return props.menuItemProps && (props.menuItemProps.onClick || props.menuItemProps.href) && css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      & > *:first-child {\n        background: ", ";\n        &:hover {\n          background: ", ";\n        }\n        &:active {\n          background: ", ";\n        }\n      }\n    "])), theme.Colors.MenuItemBackground, theme.Colors.MenuItemBackgroundHovered, theme.Colors.MenuItemBackgroundPressed);
  };
}));
export var MenuItemTitleWrapper = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  min-height: ", "px;\n  align-items: center;\n"])), Icon.defaultProps.size);